// components/bid-timer-math.js: M4-12 pure timer math.
//
// Extracted from BidTimerBar.jsx so node:test can import it without
// going through Vite's JSX loader.

/**
 * Compute the percentage (0..100) of the bid timer's bar fill at a
 * given clock reading. Synthesis §2 invariant: never extrapolate below
 * zero, a late event means the bar lands at 0 and the client waits
 * for the server's authoritative BID_TIMEOUT.
 *
 * @param {{ deadlineMs: number, durationMs: number, nowMs: number }} args
 * @returns {number} percentage in [0, 100]
 */
export function computeBidPercent({ deadlineMs, durationMs, nowMs }) {
  if (durationMs <= 0) return 0;
  const remaining = Math.max(0, deadlineMs - nowMs);
  return Math.max(0, Math.min(100, (remaining / durationMs) * 100));
}
